import { useEffect, useRef, useState } from 'react';
import {
  CalendarListExternalCalendar,
  CalendarListSchedular,
  SetExternalCalendarsRequest,
} from '../../../utils/types';
import Switch from './Switch';
import Image from 'next/image';

export type CalendarListMenuProps = {
  open: boolean;
  close: () => void;
  initialShowOnSchedularPage: boolean; //display events
  initialIncludeWithNewSchedulars: boolean; //default reserve
  schedulars: CalendarListSchedular[];
  calendar: CalendarListExternalCalendar;
  renameCalendar: (name: string) => void;
};

export default function CalendarListMenu({
  open,
  close,
  initialShowOnSchedularPage,
  initialIncludeWithNewSchedulars,
  schedulars,
  calendar,
  renameCalendar,
}: CalendarListMenuProps) {
  const [includeWithNewSchedulars, setIncludeWithNewSchedulars] =
    useState<boolean>(initialIncludeWithNewSchedulars);
  const [editingName, setEditingName] = useState<boolean>(false);
  const [displayName, setDisplayName] = useState<string>(calendar.name);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [editingName]);

  async function handleIncludeWithNewSchedulars(active: boolean) {
    const request: SetExternalCalendarsRequest = {
      externalCalendarId: calendar.id,
      excludedCalendars: calendar.excludedSchedulars,
      defaultReserve: active,
    };

    await fetch('/api/flexCals/setExcludedCalendars', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
  }

  return (
    <dialog
      open
      className="z-50 pointer-events-auto flex flex-col bg-confirmed-secondary fixed inset-0 justify-center rounded-lg shadow"
    >
      <div className="flex flex-row items-center gap-2 bg-white m-1 pl-3 py-3 pr-20 rounded-lg">
        {editingName ? (
          <input
            id="calendarName"
            type="text"
            placeholder={displayName}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm outline-none ring-2 ring-blue-500 text-black flex-grow placeholder:text-gray-800"
            ref={inputRef}
            onChange={(e) => {
              setDisplayName(e.target.value);
            }}
          />
        ) : (
          <span className="text-xl">{displayName}</span>
        )}

        {editingName ? (
          <button
            className="w-10 h-10 rounded-lg a hover:bg-gray-100 hover:shadow flex-shrink-0"
            onClick={() => {
              setEditingName(false);
              renameCalendar(displayName);
            }}
          >
            <Image
              unoptimized
              className="object-contain"
              src="/images/save.png"
              alt="save"
              width={30}
              height={30}
            />
          </button>
        ) : (
          <button
            className="w-8 h-8 rounded-lg hover:bg-gray-100 hover:shadow flex-shrink-0"
            onClick={() => setEditingName(true)}
          >
            <Image
              unoptimized
              className="object-contain"
              src="/images/edit.png"
              alt="edit"
              width={30}
              height={30}
            />
          </button>
        )}
      </div>

      <div className="bg-white m-1 pl-3 py-3 pr-20 rounded-lg text-xl whitespace-nowrap">
        <div className="flex flex-row mb-5 ">
          <span className="">Include with new schedulers</span>
          <Switch
            className="absolute right-8"
            initialToggled={includeWithNewSchedulars}
            onActivate={() => handleIncludeWithNewSchedulars(true)}
            onDeactivate={() => handleIncludeWithNewSchedulars(false)}
          />
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <button
          className="relative bg-white rounded-lg m-1 p-1 hover:bg-blue-600 hovor:shadow-lg"
          onClick={() => close()}
        >
          Close
        </button>
      </div>
    </dialog>
  );
}
